interface MangaCardProps {
  id: number;
  title: string;
  slug: string;
  cover: string;
  category: string;
  status: string;
  rating: number;
  latestChapter: string;
  views: number;
}

export default function MangaCard({
  id,
  title,
  slug,
  cover,
  category,
  status,
  rating,
  latestChapter,
  views,
}: MangaCardProps) {
  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-200">
        <img
          src={cover}
          alt={`${title} 刃牙漫画免费阅读`}
          title={`${title} - 刃牙漫画免费全集`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-md text-xs font-semibold whitespace-nowrap ${
            status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-0.5 bg-background-950/70 backdrop-blur-sm text-accent-400 px-1.5 py-0.5 rounded-md text-xs font-semibold">
          <i className="ri-star-fill text-[10px]"></i>
          {rating}
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/90 via-background-950/50 to-transparent pt-8 pb-3 px-3">
          <p className="text-background-50 text-xs truncate font-medium">
            {latestChapter}
          </p>
        </div>
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
          {title}
        </h3>
        <div className="flex items-center justify-between mt-1">
          <span className="text-xs text-foreground-500">{category}</span>
          <span className="text-xs text-foreground-400 flex items-center gap-0.5">
            <i className="ri-eye-line text-[10px]"></i>
            {formatViews(views)}
          </span>
        </div>
      </div>
    </Link>
  );
}